import * as React from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import { Button } from "components/bootstrap";
import { Row } from "common/components/layout-styles";
function FormButtons({ onRemove, isEdit = false, saving = false, onCancel = void 0 }) {
  const { t } = useTranslation("enterprise_security_events");
  const { resetForm, isValid, dirty, submitForm } = useFormikContext();
  const handleOnCancel = useCallback(() => {
    resetForm();
    onCancel == null ? void 0 : onCancel();
  }, [onCancel, resetForm]);
  return /* @__PURE__ */ React.createElement(Row, { $justify: "flex-end" }, /* @__PURE__ */ React.createElement(Button, { type: "reset", onClick: handleOnCancel }, t("form_buttons.cancel")), isEdit && /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", onClick: onRemove }, t("form_buttons.remove")), /* @__PURE__ */ React.createElement(Button, { type: "button", bsStyle: "primary", onClick: submitForm, disabled: !isValid || !dirty || saving }, isEdit ? t("form_buttons.save_event_procedure") : t("form_buttons.create_event_procedure")));
}
export default FormButtons;
